import { render, staticRenderFns } from "./TokenPair.vue?vue&type=template&id=ee69a73e&scoped=true&"
import script from "./TokenPair.vue?vue&type=script&lang=js&"
export * from "./TokenPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee69a73e",
  null
  
)

export default component.exports